import React from 'react'
import { object, string, array } from 'prop-types'

class ReviewsResults extends React.Component {
  getReviewsFromFeed () {
    const { location, pageData: { pageName } } = this.props
    let locationData = {}
    try {
      if (pageName === 'airport-parking') locationData = require('../../../../../config/exports/buildTimeOnly/reviews/airportParkingReviews.json')
      else if (pageName === 'airport-hotels') locationData = require('../../../../../config/exports/buildTimeOnly/reviews/airportHotelsReviews.json')
      else if (pageName === 'airport-lounges') locationData = require('../../../../../config/exports/buildTimeOnly/reviews/airportLoungesReviews.json')
      else if (pageName.match(/insurance/)) locationData = require('../../../../../config/exports/buildTimeOnly/reviews/insurance/all.json')
      else locationData = require('../../../../../config/exports/buildTimeOnly/reviews/' + this.getFeedPath() + location.code + '.json')
      return locationData.reviews
    } catch (e) {
      return false
    }
  }

  getMonth (month) {
    const { domainSettings: { language } } = this.props
    const months = {
      'UK': [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ],
      'de': [ 'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez' ]
    }
    return months[language][ parseInt(month, 10) - 1 ]
  }

  getReviewScoreText () {
    const { domainSettings: { language } } = this.props
    const ratingText = {
      'UK': 'out of 5',
      'de': 'von 5 Sternen'
    }
    return ratingText[language]
  }

  getFeedPath () {
    const { pageData: { productClass } } = this.props
    switch (productClass.toUpperCase()) {
      case 'CP':
        return 'parking/'
      case 'HCP':
        return 'hotels/'
      case 'HO':
        return 'hotels/'
      case 'LO':
        return 'lounges/'
    }

    return ''
  }

  renderReviews (reviews) {
    const { functionParams } = this.props
    let limit = false
    if (functionParams && functionParams[0]) limit = parseInt(functionParams[0])
    const data = Object.keys(reviews).map((key, index) => {
      if (limit && limit <= index) return null
      let review = reviews[key]
      if (
        review.comment.includes('we could not find') ||
        review.comment.includes('we couldn\'t find') ||
        review.comment.includes('we can\'t find') ||
        review.comment.includes('we can not find')
      ) return null
      let dateString = review.date ? review.date.split('-') : review.comment_date.split(' ')[0].split('-')
      dateString = dateString[2] + ' ' + this.getMonth(dateString[1]) + ', ' + dateString[0]
      return (
        <blockquote key={key} className='comment'>
          <h3>{ review.productName }</h3>
          <p>{ review.comment }</p>
          <small>{ review.name }, { dateString } ({review.rating / 2} {this.getReviewScoreText()})</small>
        </blockquote>
      )
    })

    return data
  }

  render () {
    const { id, terminal } = this.props
    const reviews = this.getReviewsFromFeed()
    return (
      <div id={id} className='contentReviews'>
        { reviews && terminal.length > 0 && (<h2>Customer Reviews</h2>) }
        { reviews && this.renderReviews(reviews) }
      </div>
    )
  }
}

ReviewsResults.propTypes = {
  id: string.isRequired,
  location: object,
  pageData: object,
  terminal: string,
  domainSettings: object,
  functionParams: array
}

ReviewsResults.defaultProps = {
  terminal: '',
  pageData: {
    pageName: ''
  }
}

export default ReviewsResults



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/reviews/reviews-results.jsx